import type { Widget, WidgetMode } from '../../common/@types'
import { API_URL } from '../../constants/environment'
import { Api } from '../../utils/api'

const api = new Api(API_URL, 'v1/widgets')

export const fetchWidget = async (appId: string, widget_mode: WidgetMode) => {
  return (await api.get<{ data: Widget }>({ path: appId, headers: { 'Ccn-App': widget_mode } }))
    .data
}
